import { render, staticRenderFns } from "./TagMaker.vue?vue&type=template&id=6f2d9be8&scoped=true&"
import script from "./TagMaker.vue?vue&type=script&lang=ts&"
export * from "./TagMaker.vue?vue&type=script&lang=ts&"
import style0 from "./TagMaker.vue?vue&type=style&index=0&id=6f2d9be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d9be8",
  null
  
)

export default component.exports